<div class="page-footer">
    <footer class="">
        <div>
           <p class="leftund"></p>
           <h4 class="facavi">FACILITIES AVAILABLE</h4>
           <p class="rightund"></p>
        </div>
        <div class="tsection">
           <p style="margin-bottom: 10px;">
              <i class="fas fa-arrows-alt"></i >
              <span class="tbrown">24 Hrs Emergency & Casualty</span
                 ><i class="fas fa-arrows-alt"></i
                 ><span class="tsky">Specialists in all Departments</span
                 ><i class="fas fa-arrows-alt"></i>
              <span class="tgreen">Laparoscopic Surgery</span
                 ><i class="fas fa-arrows-alt"></i
                 ><span class="tbrown">Paediatric Surgery</span
                 ><i class="fas fa-arrows-alt"></i
                 ><span class="tpurp">Plastic Surgery</span
                 ><i class="fas fa-arrows-alt"></i>
              <span class="tbrown">Neuro Sergery</span
                 ><i class="fas fa-arrows-alt"></i
                 ><span class="tgreen">Obstetrics & Gynaecology</span
                 ><i class="fas fa-arrows-alt"></i>
              <span class="tgreen">Cosmetic Surgery</span
                 ><i class="fas fa-arrows-alt"></i
                 ><span class="tbrown">Orthopaedic</span
                 ><i class="fas fa-arrows-alt"></i>
              <span class="tpurp">Operation Theatres</span
                 ><i class="fas fa-arrows-alt"></i><span class="tbrown">ICU</span
                 ><i class="fas fa-arrows-alt"></i><span class="tsky">ICCU</span
                 ><i class="fas fa-arrows-alt"></i
                 ><span class="tgreen">NICU/ PICU</span>
              <i class="fas fa-arrows-alt"></i><span class="tpurp">Burn Unit</span
                 ><i class="fas fa-arrows-alt"></i
                 ><span class="tbrown">TB & Chest</span
                 ><i class="fas fa-arrows-alt"></i> <span class="tsky">ENT</span
                 ><i class="fas fa-arrows-alt"></i
                 ><span class="tpurp">General Medicine</span
                 ><i class="fas fa-arrows-alt"></i
                 ><span class="tpurp">General Surgery</span
                 ><i class="fas fa-arrows-alt"></i
                 ><span class="tpurp">Cardiology</span>
              <i class="fas fa-arrows-alt"></i
                 ><span class="tpurp">Nephrology (Dialysis)</span
                 ><i class="fas fa-arrows-alt"></i><span class="tpurp">CTVS</span
                 ><i class="fas fa-arrows-alt"></i>
              <span class="tpurp">Psychiatry</span><i class="fas fa-arrows-alt"></i
                 ><span class="tpurp">Physiotherapy</span
                 ><i class="fas fa-arrows-alt"></i><span class="tpurp">Endoscopy</span
                 ><i class="fas fa-arrows-alt"></i><span>ECHO</span>
              <i class="fas fa-arrows-alt"></i><span class="tpink">X-ray</span
                 ><i class="fas fa-arrows-alt"></i
                 ><span class="tpink">Digital X-ray</span
                 ><i class="fas fa-arrows-alt"></i> <span class="tsky">CT Scan</span
                 ><i class="fas fa-arrows-alt"></i><span class="tgreen">MRI</span
                 ><i class="fas fa-arrows-alt"></i><span class="tpink">Blood Bank</span
                 ><i class="fas fa-arrows-alt"></i><span class="tsky">Pathology</span
                 ><i class="fas fa-arrows-alt"></i>
              <span class="tgreen">Trauma Care Unit</span
                 ><i class="fas fa-arrows-alt"></i
                 ><span class="tpink">Hi-Test Tube Baby Research Center</span
                 ><i class="fas fa-arrows-alt"></i
                 ><span class="tgreen">24Hrs Pharmacy</span
                 ><i class="fas fa-arrows-alt"></i
                 ><span class="tpink">24Hrs Ambulance Services</span>
              <i class="fas fa-arrows-alt"></i
                 ><span class="tsky">Help Line Number : 1800 345 1212</span>
           </p>
        </div>
        <h4 class="facavi">
           (Please bring this prescription at each visit. This prescription is valid upto 7days
           from the ticket date)
        </h4>
     </footer>
</div>
